/* eslint-disable global-require,import/no-unresolved,max-len, react/forbid-prop-types, no-useless-concat, no-param-reassign, no-return-assign, consistent-return, class-methods-use-this */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Text, View } from 'react-native'
import styles from '../../styles'
import textStyles from '../../styles/text'

class BulletedListView extends Component {
  renderItem(item, i) {
    return (
      <View key={`${i}`} style={styles.detailColumn}>
        <View style={styles.detailRow}>
          <View style={styles.width10}>
            <Text style={styles.shark_grey}>{'\u2022' + ' '}</Text>
          </View>
          <View style={styles.bulletText}>
            {item}
          </View>
        </View>
      </View>
    )
  }

  render() {
    const {
     headingText, testID, children, accessibilityLabel,
    } = this.props
    return (
      <View testID={testID} style={{ paddingBottom: 18 }} accessibilityLabel={accessibilityLabel}>
        {headingText ? <Text style={textStyles.detailText} testID="bullet-list-view-header">{headingText}</Text> : null}
        {children.length ? children.map((child, i) => this.renderItem(child, i)) : this.renderItem(children)}
      </View>
    )
  }
}

BulletedListView.propTypes = {
  headingText: PropTypes.string,
  testID: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  children: PropTypes.instanceOf(Object).isRequired,
}

BulletedListView.defaultProps = {
  testID: 'bullet-list',
  headingText: null,
  accessibilityLabel: null,
}

export default BulletedListView
